import React, { useCallback, useState } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import classNames from 'classnames'
import useHoverDelay from 'Components/hooks/use-hover-delay'

interface IProps {
  className?: string
  title?: JSX.Element | string
  navList?: { link: string; label: string; icon?: string; active?: boolean }[]
  onChange?: (id: string, isIinit?: boolean) => void
  onTitleClick: () => void
  isFixed?: boolean
}

const FloorTabTitle: React.FC<IProps> = ({
  className = '',
  title,
  navList = [],
  onChange,
  onTitleClick,
  isFixed,
}) => {
  const [swiper, setSwiper] = useState<any>(null!)
  const [list, setList] = useState(() => {
    const hitItem = navList.find((item) => item.active)
    if (!hitItem && navList.length > 0) {
      navList[0].active = true
    }
    onChange && onChange(navList[0]?.link, true)
    return navList
  })

  const handleMouseOver = useCallback(
    (id) => {
      const hitItem = list.find((item) => item.active)
      if (hitItem && hitItem.link === id) {
        return
      }

      let hiteIndex = -1
      const newList = list.map((item, index) => {
        if (item.link === id) {
          hiteIndex = index
        }
        return {
          ...item,
          active: item.link === id ? true : false,
        }
      })

      setList(newList as any)
      onChange && onChange(id)

      if (hiteIndex / list.length > 0.5) {
        swiper.slideNext()
      } else {
        swiper.slidePrev()
      }
    },
    [onChange, list, swiper]
  )

  const [start, cancel] = useHoverDelay(handleMouseOver)

  return (
    <div
      className={classNames('floor-tab-title', className, {
        'tw-pb-12': !isFixed,
        'tw-pb-0': isFixed,
      })}
    >
      {title && (
        <div className="title" onClick={onTitleClick}>
          {title}
        </div>
      )}
      {list?.length > 0 && (
        <div className="container">
          <Swiper
            spaceBetween={0}
            watchOverflow={true}
            slidesPerView={'auto'}
            preventClicks={false}
            onSwiper={setSwiper}
            simulateTouch={false}
            loop={false}
            resizeObserver={true}
          >
            {list.map((item, index) => {
              return (
                <SwiperSlide style={{ width: 'auto' }} key={index}>
                  <div
                    className={classNames('nav-item', {
                      active: item.active,
                      'tw-pb-26': isFixed,
                    })}
                    key={index}
                    onMouseOver={() => start(item.link)}
                    onMouseLeave={cancel}
                  >
                    <span>{item.label}</span>
                  </div>
                </SwiperSlide>
              )
            })}
          </Swiper>
          <div className="nav-wrap" />
        </div>
      )}
      <style jsx>
        {`
          .container {
            width: 100%;
            overflow: hidden;
            overflow-x: auto;
          }
          .floor-tab-title {
            width: 100%;
            align-items: center;
          }
          .title {
            font-family: PingFangSC;
            font-size: 20px;
            font-weight: 600;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            letter-spacing: normal;
            color: #1f2129;
          }
          .nav-wrap {
            flex: 1;
            display: flex;
            align-items: center;
          }
          .nav-item {
            position: relative;
            margin-right: 24px;
            font-family: PingFangSC;
            font-size: ${isFixed ? '18px' : '16px'};
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            letter-spacing: normal;
            color: #606370;
            width: auto;
            margin-right: 20px;
          }
          .nav-item.active {
            font-size: ${isFixed ? '18px' : '20px'};
            font-weight: 500;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            letter-spacing: normal;
            color: #1f2129;
            position: relative;
            top: ${isFixed ? '0px' : '-3px'};
          }
          .nav-item.active::after {
            display: block;
            position: absolute;
            content: '';
            bottom: ${isFixed ? '0px' : '-4px'};
            left: 0;
            right: 0;
            margin: 0 auto;
            width: ${isFixed ? '100%' : '20px'};
            height: 4px;
            background-color: #ffcc32;
          }
          .nav-item:last-child {
            border-right: none;
          }
          .nav-item span {
            cursor: pointer;
          }
        `}
      </style>
    </div>
  )
}

export default FloorTabTitle
